<template>
  <div id="intelligentDetecte">
    <template v-if="$route.name === 'intelligentDetecte'">
        <ots-main-title></ots-main-title>
        <el-form>
            <div class="mainCon mainBox">
                <div style="display:flex; flex-wrap: wrap;" class="intelligentDetecte">
                    <el-form-item label="课程名称：" style="margin-right: 16px;">
                        <el-select v-model="courseId" filterable>
                            <el-option v-for="item in courseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="试题状态：" style="margin-right: 16px;">
                        <el-select v-model="questionState" placeholder="请选择" filterable>
                            <el-option v-for="item in questionStateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="题型：" style="margin-right: 16px;">
                        <el-select v-model="questionTypeId" placeholder="请选择" filterable>
                            <el-option v-for="item in questionTypeIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div style="display: flex; align-items: center; gap: 16px;">
                    <el-button type="primary" round @click="getCount"> 查询 </el-button>
                    <div v-if="questionCountShow" style="font-size: 14px; font-weight: bold;">共检索试题 <span style="font-size:18px; color: brown;">{{ questionCount }} </span>道</div>
                </div>
            </div>

            <div class="mainConOther" v-if="templateShow">
                <div style="display:flex; flex-wrap: wrap;" class="intelligentDetecte">
                    <el-form-item label="检测模板：" style="margin-right: 16px; padding-left: 15px;">
                        <el-select v-model="templateId" placeholder="请选择" filterable>
                            <el-option v-for="item in templateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-button type="primary" round @click="checkTask" style="width: 100px; height: 40px;"> 开始检测 </el-button>
                </div>
            </div>
        </el-form>
        <div class="mainCon">
            <ots-table :tableHeader="tableHeader" :tableData="tableData"></ots-table>
            <ots-pagination :pagination="pagination" @changeNum="changeSize" @changePage="changePage"></ots-pagination>
        </div>
    </template>
    <template v-else>
        <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { getPlanCourseList } from "@/http/modules/custom";
import {
  getDetecteTemplateByIdApi,
  getListDetecteTemplateApi,
  addDetecteTemplateApi,
  updateDetecteTemplateApi,
  deleteDetecteTemplateApi,
  intelligentDetecte4OtsApi,
  getTaskListApi,
  getTaskItemApi,
  createTask4IntelligentDetecteApi,
  deleteTaskApi,
  stopTaskApi,
  getOtsQuestionCountApi,
  generateTaskReportApi,
  getQuestionStateApi,
  getQuestionTypeApi,
  createTask4CheckSimilarApi
 } from "@/http/modules/dataV";


export default {
  name: "intelligentDetecte",
  data () {
    return {
      courseList:[], // 课程列表
      courseId: "",
      questionStateList:[], // 试题状态列表
      questionState: "",
      questionTypeIdList:[], // 题型列表
      questionTypeId: "",
      templateList:[], // 检测模板列表
      templateId: "",
      selectCourseId : "",
      selectQuestionState : "",
      selectQuestionTypeId : "",
      questionCount : 0, //试题数量
      questionCountShow : false, //是否显示试题数量
      templateShow : false, //是否显示检测模板
      /* ** 表单参数 ** */
      selectForm: {
        courseId : '',
        questionState : '',
        questionTypeId : ''
      },
      /* ** 表格头配置 ** */
      tableHeader: [
        {
          title: "序号",
          prop: "orderId",
          width: "60"
        },
        {
          title: "检测课程",
          prop: "courseName",
          width: "250"
        },
        {
          title: "检测试题数量",
          prop: "taskTotalCount",
          width: "120"
        },
        {
          title: "检测开始时间",
          prop: "createDate",
          width: "115"
        },
        {
          title: "检测完成时间",
          prop: "taskFinishDate",
          width: "115"
        },
        {
          title: "检测进度",
          prop: "detecteStateDesc"
        },
        {
          title:"查看",
          type: "buttons",
          width:"190",
          btnList:[
            {
              title:"试题检测项",
              click: this.taskOption,
              type: "tooltip",
              data: function(scope) {
                let DOM = "";
                scope.row.detecteItemNames.map(e => {
                    let item = `<div style="line-height:25px; padding:1px 5px 1px 5px;">${e}</div>`
                    DOM += item;
                })
                return DOM;
              },
            },
            {
              title:"检测结果详情",
              click: this.taskResult,
              disableFn: function(scope) { //检测状态：0试题准备中、1待检、2检测中、3终止、4完成
                return ![2, 3, 4].includes(scope.row.detecteState);
              }
            }
          ]
        },
        {
          title:"操作",
          width:"220",
          type: "buttons_set",
          fixed: "right",
          align: "right",
          headerAlign: "right",
          disabled: true,
          tableSettings: {
            content: "刷新",
            icon: 'el-icon-refresh',
            click: this.pageRefresh,
          },
          btnList:[
            {
              title:"删除",
              click: this.deleteTask,
              formatter: function(scope) { //检测状态：0试题准备中、1待检、2检测中、3终止、4完成
                return ![0, 1].includes(scope.row.detecteState);
              }
            },
            {
              title:"终止检测",
              click: this.stopTask,
              formatter: function(scope) { //检测状态：0试题准备中、1待检、2检测中、3终止、4完成
                return scope.row.detecteState !== 2;
              }
            },
            {
              title:"下载检测报告",
              click: this.downloadReport,
              formatter: function(scope) { //检测状态：0试题准备中、1待检、2检测中、3终止、4完成
                return ![3, 4].includes(scope.row.detecteState);
              }
           }
          ]
        }
      ],
      /* ** 表格数据 ** */
      tableData: [],
      /* ** 数据总数(分页) ** */
      pagination: {
        total: 0
      },
      /* ** 分页参数 ** */
      taskListParams: {
        // orders: 'createDate desc',
        page: 1,
        size: 10
      }
    }
  },
  mounted () {
    this.initData();
    this.getAllTaskFn(); //查询任务列表
  },

  methods: {
    async initData() {
      // 获取课程列表
      const { data: courseDataList } = await getPlanCourseList({ planId : ""});
      this.courseList = courseDataList.map(item => ({ id: item.courseId, name: item.courseName }));
      this.courseId = courseDataList[0].courseId;

      // 获取试题状态列表
      const { data: questionStateMap } = await getQuestionStateApi();
      const questionStateMapResult = Object.entries(questionStateMap).map(([id, name]) => ({ id, name }));
      this.questionStateList = [{id: "", name: "全部"},...questionStateMapResult]

      // 获取题型列表
      const { data: questionTypeMap } = await getQuestionTypeApi();
      const questionTypeMapResult = Object.entries(questionTypeMap).map(([id, name]) => ({ id, name }));
      this.questionTypeIdList = [{id: "", name: "全部"},...questionTypeMapResult]

      // 获取检测模板列表
      const { data: templateList } = await getListDetecteTemplateApi({ page: 1, size: 1000 });
      const templateListResult = templateList?.records || [];
      this.templateList = templateListResult;
      const defaultTemplate = templateListResult.find(item => item.isDefault === 1);

      if (defaultTemplate) {
        this.templateList[0].defaultValue = defaultTemplate.id;
        this.templateId = defaultTemplate.id;
      }
    },
    /**********************************
     * @deleteTask 删除任务
     **********************************/
    deleteTask (row) {
      // (1) 确认数据
      if (!row) {
        return false
      }
      // (2) 拼接参数
      let param = {
        taskId: row ? row.id : ""
      }
      // (3) 删除确认弹窗
      this.$confirm('确定删除该任务?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { code,data } = await deleteTaskApi(param)
          if (code == 1) {
            this.$message.success(data)
            this.getAllTaskFn()
          }
        }).catch(() => {})
    },

    /**********************************
     * @stopTask 终止检测
     **********************************/
    stopTask (row) {
      // (1) 确认数据
      if (!row) {
        return false
      }
      // (2) 拼接参数
      let param = {
        taskId: row ? row.id : ""
      }
      // (3) 终止该任务的检测
      this.$confirm('确定终止该任务的检测?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const { code,data } = await stopTaskApi(param)
          if (code == 1) {
            this.$message.success(data)
            this.getAllTaskFn()
          }
        }).catch(() => {})
    },
    /**********************************
     * @getAllTaskFn 获取表格数据
     **********************************/
    async getAllTaskFn () {
      this.taskParams = Object.assign(this.taskListParams)
      let resultData = await getTaskListApi(this.taskParams);
      let resultInfo = resultData.data;
      for(let i=0;i<resultInfo.records.length;i++){
        let oCurItem = resultInfo.records[i];
        oCurItem["orderId"] = i+1;
      }
      this.tableData = resultInfo.records;
      this.pagination.total = resultInfo.total;
    },
    /**********************************
     * @taskOption 试题检测项
     **********************************/
    taskOption (row) {
      if (!row) {
        return false
      }
    },
    /**********************************
     * @getCount 获取要检测的试题数量
     **********************************/
    async getCount () {
      const params = {
        courseId:this.courseId,
        questionState:this.questionState,
        questionTypeId:this.questionTypeId
      };
      const { data } = await getOtsQuestionCountApi(params)
      this.questionCount = data
      this.questionCountShow = true
      this.templateShow = data > 0 ? true : false;
      this.selectCourseId = this.courseId;
      this.selectQuestionState = this.questionState;
      this.selectQuestionTypeId = this.questionTypeId;
    },
    /**********************************
     * @checkTask 检测任务
     **********************************/
    async checkTask () {
      //待检测的试题数量必须大于0
      if (this.questionCount <= 0) {
        this.$message.warning("当前没有可检测的试题");
        return false;
      }
      if (this.templateId == "") {
        this.$message.warning("请选择检测模板");
        return false;
      }
      //验证是否已有相同任务
      const params = {
        courseId:this.selectCourseId,
        questionState:this.selectQuestionState,
        questionTypeId:this.selectQuestionTypeId,
        templateId:this.templateId
      };
      const { data } = await createTask4CheckSimilarApi(params);
      if (data) {
        this.$confirm('当前存在相同查询条件的任务，确认要继续创建任务吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.submitTask();
          this.questionCountShow = false;
          this.templateShow = false;
        }).catch(() => {})
      }else{
        this.submitTask();
        this.questionCountShow = false;
        this.templateShow = false;
      }
    },
    async submitTask () {
      //获取模板名称
      const selectTemplate = this.templateList.find(
        item => item.id === this.templateId
      );
      const templateName = selectTemplate ? selectTemplate.name : "";

      const params = {
        courseId:this.selectCourseId,
        questionState:this.selectQuestionState,
        questionTypeId:this.selectQuestionTypeId,
        templateId:this.templateId,
        templateName
      };

      const { code: resultCode,data : resultData } = await createTask4IntelligentDetecteApi(params);
      if (resultCode == 1) {
        this.$message.success(resultData);
        this.getAllTaskFn();
      }
    },
    /* *** 分页相关 *** */
    changeSize(num) {
        this.taskListParams.size=num
        this.getAllTaskFn()
    },

    /* *** 分页相关 *** */
    changePage(p) {
        this.taskListParams.page=p
        this.getAllTaskFn()
    },
    /**********************************
     * @downloadReport 下载报告
     **********************************/
    downloadReport(row){
      // (1) 确认数据
      if (!row) {
        return false
      }
      // (2) 拼接参数
      let param = {
        taskId: row ? row.id : ""
      }
      // (3) 下载报告
      generateTaskReportApi(param).then((res)=>{
        if(res.code == 1){
          if(res.data?.url){
            window.open(res.data.url,"_blank");
          }else{
            this.$message.warning(res.data?.msg || "报告生成中，请稍后重试")
          }
        }else{
          this.$message.error("下载失败")
        }
      })
    },
    /**********************************
     * @taskResult 检测结果详情
     **********************************/
    taskResult(row) {
      this.$router.push({
        name: "taskResult",
        query: {
          id: row.id,
        },
      });
    },
    pageRefresh(){
      this.getAllTaskFn()
    }
  }
}
</script>

<style lang="less" scoped>
.default-upload-container {
  box-sizing: border-box;
  width: 240px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  background: rgba(255, 255, 255, 0.35);
  color: #c2c4cc;
  font-size: 13px;
  line-height: 36px;
  text-align: left;
  padding-left: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.intelligentDetecte /deep/ .el-form-item__content {
  display: flex;
}
.mainConOther {
    margin-top: 16px;
    padding: 10px;
    height: 50px;
    padding-top: 20px;
    line-height: 50px;
    background: #fff;
    border-radius: 8px;
}
</style>